import { Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
@Component({
	selector: 'spinner',
	templateUrl: "./spinner.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./spinner.scss")]
})
export class Spinner {
	private static defaultMinDisplayTimeMs = 1500;
	private static defaultMinWatinginTimeMs = 100;

	@Input() minDisplayTimeMs;
	@Input() minWaitingTimeMs;
	@Output() hide: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() middleText: string;

	private _visible: boolean;
	private timestampOfVisibility: number;
	private lastSettedVisible: boolean;

	public constructor(private changeDetectorRef: ChangeDetectorRef) {

	}
	@Input() set visible (visible: boolean){
		this.lastSettedVisible = visible;
		if (visible) {
			this.timestampOfVisibility = Date.now();
			setTimeout(() => {
					this._visible = this.lastSettedVisible;
					this.changeDetectorRef.markForCheck();
			}, this.getMinWaitingTime())


		}
		if (!visible) {
			if (this.calcTimestampForHide(this.timestampOfVisibility) < Date.now()) {// Everything is ok just hide
				this.hideSpinner();
			} else {
				let displayTime = this.calcTimetoDisplay(this.timestampOfVisibility)
				setTimeout(() => {
					this.hideSpinner();
					this.changeDetectorRef.markForCheck();
				}, displayTime);
			}
		}
	}

	private hideSpinner() {
		this._visible = false;
		this.timestampOfVisibility = 0;
		this.hide.emit(true);
	}

	get visible(): boolean{
		return this._visible;
	}

	private calcTimestampForHide= (timestamp: number) => {
		if (!timestamp) {
			return 0;
		}
		let calcTimestampForHide = timestamp + this.getMinDisplayTime();
		return calcTimestampForHide;
	}

	private calcTimetoDisplay = (timestamp: number) => {
		return this.calcTimestampForHide(timestamp) - Date.now();
	}

	private getMinDisplayTime = (): number => {
		if (this.minDisplayTimeMs) {
			return this.minDisplayTimeMs
		}
		return Spinner.defaultMinDisplayTimeMs
	}

	private getMinWaitingTime= (): number => {
		if (this.minWaitingTimeMs) {
			return this.minWaitingTimeMs
		}
		return Spinner.defaultMinWatinginTimeMs
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/spinner/spinner.component.ts